<div class="modal-header">

    <div class="d-flex align-items-center">

        <div class="avatar-title me-3">
            <i class="bx bx-shield-quarter"></i>
        </div>

        <div>
            <h4 class="modal-title mb-0 text-white">
                Validación de Seguridad
            </h4>

            <small>
                Esta operación requiere autorización mediante Token.
            </small>
        </div>

    </div>

</div>

<div class="modal-body">

    <div class="row g-4">

        <!-- PANEL IZQUIERDO -->

        <div class="col-lg-4">

            <div class="card h-100">

                <div class="card-body">

                    <div class="text-center mb-4">

                        <div class="security-icon mb-3">
                            <i class="bx bx-lock-alt"></i>
                        </div>

                        <h5 class="fw-bold">
                            Autorización
                        </h5>

                        <p class="text-muted mb-0">
                            Selecciona el método para autorizar la operación.
                        </p>

                    </div>

                    <ul
                        ngbNav
                        #verticalNav="ngbNav"
                        [activeId]="1"
                        class="nav-pills flex-column">

                        <li [ngbNavItem]="1">

                            <a ngbNavLink>

                                <i class="bx bx-key me-2"></i>

                                Tengo Token

                            </a>

                            <ng-template ngbNavContent>

                                <div class="content-panel">

                                    <div class="alert alert-primary border-0">

                                        <i class="bx bx-info-circle me-2"></i>

                                        Ingresa el token enviado por el administrador.

                                    </div>

                                    <label class="form-label fw-semibold">

                                        Token

                                    </label>

                                    <input
                                        type="text"
                                        class="form-control form-control-lg"
                                        [(ngModel)]="toketxt"
                                        placeholder="Ej. A8X9-KL2P">

                                    <button
                                        class="btn btn-success w-100 mt-4"
                                        [disabled]="!toketxt"
                                        (click)="validar()">

                                        <i class="bx bx-check-circle me-2"></i>

                                        Validar Token

                                    </button>

                                </div>

                            </ng-template>

                        </li>

                        <li [ngbNavItem]="2">

                            <a ngbNavLink>

                                <i class="bx bx-user-plus me-2"></i>

                                Solicitar Token

                            </a>

                            <ng-template ngbNavContent>

                                <div class="content-panel">

                                    <div class="alert alert-warning border-0">

                                        <i class="bx bx-error-circle me-2"></i>

                                        Selecciona un administrador para solicitar un nuevo token.

                                    </div>

                                    <label class="form-label fw-semibold">

                                        Administrador

                                    </label>

                                    <ng-select
                                        [(ngModel)]="usuario"
                                        placeholder="Selecciona un administrador">

                                        <ng-option
                                            *ngFor="let usuario of usuarios"
                                            [value]="usuario">

                                            {{usuario.name}}

                                        </ng-option>

                                    </ng-select>

                                    <button
                                        class="btn btn-primary w-100 mt-4"
                                        [disabled]="!usuario"
                                        (click)="solicitarToken()">

                                        <i class="bx bx-send me-2"></i>

                                        Solicitar Token

                                    </button>

                                </div>

                            </ng-template>

                        </li>

                    </ul>

                </div>

            </div>

        </div>

        <!-- PANEL DERECHO -->

        <div class="col-lg-8">

            <div class="card h-100">

                <div class="card-body">

                    <div [ngbNavOutlet]="verticalNav"></div>

                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal-footer">

    <button
        class="btn btn-light"
        (click)="activeModal.dismiss()">

        <i class="bx bx-x me-1"></i>

        Cancelar

    </button>

</div>